/**
 * Класс для сбора информации о текущем пользователе для маркетинговых исследований.
 * Собирает данные об устройстве, браузере, сети, языке и аналитических UUID.
 * v.0.1.250429 - начальная версия
 */
class getUserInfo {
  /**
   * Получить разрешение экрана в формате "{width}x{height}px".
   * @returns {string} Например "1920x1080px".
   */
  static getScreenResolution() {
    return `${window.screen.width}x${window.screen.height}px`
  }

	/**
   * Получить размер viewport окна в формате "{width}x{height}px".
   * @returns {string} Например "1280x720px".
   */
  static getViewportResolution() {
    return `${window.innerWidth}x${window.innerHeight}px`;
  }

  /**
   * Определить операционную систему.
   * @returns {string} Название ОС.
   */
  static getOS() {
    const ua = navigator.userAgent;
    if (/Windows NT/.test(ua))      return 'Windows'
    if (/Mac OS X/.test(ua))        return 'macOS'
    if (/Android/.test(ua))         return 'Android'
    if (/iPhone|iPad|iPod/.test(ua))return 'iOS'
    if (/Linux/.test(ua))           return 'Linux'
    return '--'
  }

  /**
   * Определить тип устройства по userAgent.
   * @returns {string} "Mobile", "Tablet" или "Desktop".
   */
  static getDeviceType() {
    const ua = navigator.userAgent.toLowerCase()
    if (/mobile/.test(ua)) return 'Mobile'
    if (/tablet/.test(ua)) return 'Tablet'
    return 'Desktop'
  }

  /**
	 * Определить браузер и его версию.
	 * @returns {string} Например "Chrome 112.0.5615.49" или "Unknown".
	*/
  static getBrowser() {
		const ua = navigator.userAgent
    let m
    if ((m = ua.match(/Edg\/([\d\.]+)/)))         return `Edge ${m[1]}`
    if ((m = ua.match(/OPR\/([\d\.]+)/)))         return `Opera ${m[1]}`
    if ((m = ua.match(/Chrome\/([\d\.]+)/)))      return `Chrome ${m[1]}`
    if ((m = ua.match(/Firefox\/([\d\.]+)/)))     return `Firefox ${m[1]}`
    if ((m = ua.match(/Version\/([\d\.]+).*Safari/))) return `Safari ${m[1]}`
		return '--'
  }

  /**
   * Получить userAgent.
   * @returns {string}
   */
  static getUserAgent() {
    return navigator.userAgent.toLowerCase()
  }

  /**
   * Язык интерфейса пользователя.
   * @returns {string} Пример: "ru-RU".
   */
  static getLanguage() {
    return navigator.language || ''
  }

  /**
   * Часовой пояс пользователя.
   * @returns {string} Пример: "Europe/Moscow".
   */
  static getTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || ''
  }

  /**
   * Извлечь значение cookie по имени.
   * @param {string} name
   * @returns {string|null}
   * @private
   */
  static _getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  /**
   * Yandex Metrica UUID (_ym_uid из cookie).
   * @returns {string|null}
   */
  static getYandexUUID() {
    return this._getCookie('_ym_uid');
  }

  /**
   * Google Analytics Client ID (_ga из cookie).
   * @returns {string|null}
   */
  static getGoogleUUID() {
    return this._getCookie('_ga');
  }

  /**
   * Собрать все доступные данные в один объект.
   * @returns {Object}
   */
  static getAll() {
    return {
      deviceType:       	this.getDeviceType(),
      operatingSystem:  	this.getOS(),
      browser:          	this.getBrowser(),
      screenResolution: 	this.getScreenResolution(),
			viewportResolution: this.getViewportResolution(),
      browserLanguage:    this.getLanguage(),
      timeZone:         	this.getTimeZone(),
      yandexUUID:       	this.getYandexUUID(),
      googleUUID:       	this.getGoogleUUID(),
      userAgent:          this.getUserAgent()
    };
  }
}